import environment from '@/modules/perseo-billing/environments/environment';

export const AuthenticationForm = () => {
  const scotiabankUrl = environment.SCOTIABANK_URL;

  return (
    <form
      id="autorizadorPARIS"
      name="autorizadorPARIS"
      action={scotiabankUrl}
      method="post"
      // target='_blank'
    >
      <button hidden type="submit">
        autorizador PARIS
      </button>
    </form>
  );
};
